import { VectorLayer } from './Layer';
import { outlineFeatureHighlightCounty, outlineFeatureHighlightCensus } from './MapVectorStyles.js';
import { useEffect, useContext, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { FeatureContext } from '../model/FeatureProvider';

const FeatureOutlineLayer = (props) => {
    const { map, zIndex } = props;
    const { hoveredFeature } = useContext(FeatureContext);
    const { selectedFeature, selectedFeatureIsPinned: pinned } = useContext(InterfaceContext);
    const [localFeatures, setLocalFeatures] = useState([]);
    const [style, setStyle] = useState(outlineFeatureHighlightCounty);

    const updateFeature = (featr) => {
        if (featr) {
            const fips = featr.get('FIPS');
            const clonedFeature = featr.clone();
            var borderStyle = fips?.length > 5 ? outlineFeatureHighlightCensus : outlineFeatureHighlightCounty;
            clonedFeature.setStyle(borderStyle);
            setLocalFeatures([clonedFeature]);
            setStyle(borderStyle);
        } else {
            setLocalFeatures(null);
        }
    };
    // useEffect(() => setLocalFeatures([]), [tract]);
    useEffect(() => !pinned && updateFeature(hoveredFeature), [hoveredFeature]);
    useEffect(() => !pinned && setLocalFeatures([]), [pinned]);
    useEffect(() => pinned && selectedFeature && updateFeature(selectedFeature), [selectedFeature]);

    return <VectorLayer title={'Highlighted Feature'} style={style} features={localFeatures} zIndex={zIndex} opacity={1} visible={true} map={map} />;
};
export { FeatureOutlineLayer };
